import { RootState } from '@/shared';

export const selectGiveawayLoading = (s: RootState) => s.giveaway.loading;
export const selectGiveawayError = (s: RootState) => s.giveaway.error;
export const selectGiveawayFetchError = (s: RootState) => s.giveaway.fetchError;
export const selectGiveawayData = (s: RootState) => s.giveaway.giveawayData;
